
import { defineComponent, ref, computed } from 'vue'
import { Field as VeeField } from 'vee-validate'
export default defineComponent({
  name: 'TextField',
  components: {
    VeeField
  },
  props: {
    name: {
      type: String,
      default: () => null
    },

    type: {
      type: String,
      default: () => 'text'
    },
    title: {
      type: String,
      default: () => null
    },
    placeholder: {
      type: String,
      default: () => null
    },
    modelValue: {
      type: String,
      default: () => null
    },
    rules: {
      type: String,
      default: () => ''
    }
  },
  emits: ['update:modelValue'],
  setup(props, { slots }) {
    //const value = ref(props.modelValue)
    const hasErrorSlotPopulate = computed(() => {
      return !!slots.error
    })
    return { hasErrorSlotPopulate }
  }
})
